import React from "react";
import { Link, Outlet, NavLink } from "react-router-dom";

const ITEMS = [
  { to: "/settings/profile", label: "Profile", testid: "settings-nav-profile" },
  { to: "/settings/organization", label: "Organization", testid: "settings-nav-org" },
  { to: "/settings/security", label: "Security", testid: "settings-nav-security" },
  { to: "/settings/team", label: "Team", testid: "settings-nav-team" },
  { to: "/settings/billing", label: "Billing", testid: "settings-nav-billing" },
  { to: "/settings/notifications", label: "Notifications", testid: "settings-nav-notifications" },
];

export default function SettingsLayout() {
  return (
    <div className="max-w-7xl mx-auto" data-testid="settings-layout">
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-orange-500/80 mb-2">Settings</p>
      <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight text-zinc-50" style={{ fontFamily: "var(--font-heading)" }}>
        Workspace Settings
      </h1>

      <div className="mt-10 grid grid-cols-1 lg:grid-cols-[200px_1fr] gap-10">
        <nav className="flex lg:flex-col gap-1 overflow-x-auto scrollbar-thin">
          {ITEMS.map((i) => (
            <NavLink
              key={i.to}
              to={i.to}
              data-testid={i.testid}
              className={({ isActive }) =>
                `px-3 py-2 rounded-lg text-sm whitespace-nowrap transition-colors ${
                  isActive ? "bg-zinc-800 text-white" : "text-zinc-400 hover:text-white hover:bg-zinc-800/60"
                }`
              }
            >
              {i.label}
            </NavLink>
          ))}
        </nav>
        <div className="max-w-3xl"><Outlet /></div>
      </div>
    </div>
  );
}
